import React from 'react'
import PropTypes from "prop-types";
import { idEmpresa } from '../../../constans/constants';


class ModalDetalleUsuario extends React.Component {

  state = {
    loading: false,
    datos: null,
    roles: null
  };

  dialogRef = React.createRef();

  componentDidUpdate(prevProps) {
    if (!prevProps.abierto && this.props.abierto) {
      const dialog = this.dialogRef.current;

      if (dialog && typeof dialog.showModal === "function") {
        requestAnimationFrame(() => {
          dialog.showModal();
        });
      }
    }

    if (prevProps.abierto && !this.props.abierto) {
      this.dialogRef.current?.close();
    }
  }

  cargarDetalles = (dato) => {

    this.setState({ loading: true, datos: dato });

    this.props
      .fetchDetalle(dato.id)
      .then((resultados) => {
        let arr = []
        arr.push(resultados.datos.find(elemento => elemento.id == idEmpresa()))
        this.setState({ roles: arr, loading: false });
      })
      .catch((error) => {
        console.error("Error al cargar los detalles:", error);
        this.setState({ loading: false });
      });

  };

  renderContenido = () => {
    const { loading, datos, roles } = this.state;

    if (loading) return <p>Cargando...</p>;
    if (!datos) return <p>No se pudieron cargar los detalles.</p>;

    return this.props.renderContenido(datos, roles);
  };

  handleCerrar = () => {
    this.dialogRef.current?.close();
    if (this.props.onClose) this.props.onClose();
  };

  render() {
    const { titulo } = this.props;

    return (
      <div className="component-modal-side">
        <dialog
          className="modal"
          id="modal-detalle-usuario"
          ref={this.dialogRef}
        >
          <button
            className="btn-medium btn-circle-icon btn-primary-tonal"
            id="close-modal"
            onClick={this.handleCerrar}
          >
            <span className="material-symbols-outlined">close</span>
          </button>

          <div className="modal-content">
            <div className="modal-head">
              <h4 className="modal-title">{titulo || "Detalles"}</h4>
            </div>
            <div className="modal-body">{this.renderContenido()}</div>
          </div>
        </dialog>
      </div>
    );
  }
}

ModalDetalleUsuario.propTypes = {
  abierto: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  titulo: PropTypes.string,
  fetchDetalle: PropTypes.func.isRequired,
  renderContenido: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["sm", "md"]),
};

export default ModalDetalleUsuario;